import { gql } from '@apollo/client';

export const GET_INVOICE_QUERY = gql`
  query GetInvoice($filter: InvoiceFilter!, $pagination: PaginationInput) {
    getInvoice(filter: $filter, pagination: $pagination) {
      data {
        id
        recordId
        pdf
        invoiceNumber
        invoiceDate
        invoiceNoJobs
        invoiceDiscount
        pdfName
        invoiceTotal
        customer
        jobs {
          id
          reference {
            referenceNumber
            from
            to
          }
          number
          bolNumber
          commodity {
            quantity
            description
            weight
            weightUnit
          }
          charges {
            currency
            total
            items {
              name
              amount
            }
          }
          podInfo {
            podSignedBy
            dateTime
          }
        }
      }
      pagination {
        total
        size
        page
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_DATE_INVOICE_QUERY = gql`
  query DateInvoice($filter: dateInvoiceFilter!, $pagination: PaginationInput) {
    getDateInvoice(filter: $filter, pagination: $pagination) {
      data {
        recordId
        invThreeOne
        ageing {
          current
          total_due
          days_31_60
          days_61_90
          over_90_days
        }
        invNineOne
        rangeStart
        invTotal
        rangeEnd
        internalEnd
        invoiceNumber {
          originalAmount
          invoiceNumber
          noOfJobs
          currency
          invoiceDate
          openAmount
        }
      }
      pagination {
        total
        size
        page
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_INVOICE_TRANSACTION_HISTORY_QUERY = gql`
  query InvoiceTransactionHistoryQuery($invoiceNumber: String) {
    getInvoiceTransactionHistory(invoiceNumber: $invoiceNumber) {
      id
      recordId
      invoiceDate
      invoiceTotal
      invoiceOpenBalance
      transactions {
        date
        action
        amount
        comment
      }
    }
  }
`;

export const GET_STATEMENT_LIST_QUERY = gql`
  query StatementListQuery($id: String) {
    getStatementList(id: $id) {
      data {
        recordId
        invThreeOne
        ageing {
          current
          total_due
          days_31_60
          days_61_90
          over_90_days
        }
        invNineOne
        rangeStart
        invTotal
        rangeEnd
        internalEnd
        invoiceNumber {
          originalAmount
          invoiceNumber
          noOfJobs
          currency
          invoiceDate
          openAmount
        }
      }
      pagination {
        total
        size
        page
        totalPages
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const EMAIL_INVOICE_MUTATION = gql`
  mutation EmailInvoiceMutation($customer: String, $invNumber: String) {
    emailInvoice(customer: $customer, invNumber: $invNumber) {
      result
    }
  }
`;

export const GENERATE_INVOICE_REPORT_MUTATION = gql`
  mutation GenerateInvoiceReportMutation(
    $accountNumber: String
    $reportName: String
    $startDate: Date
    $endDate: Date
  ) {
    generateInvoiceReport(
      accountNumber: $accountNumber
      reportName: $reportName
      startDate: $startDate
      endDate: $endDate
    ) {
      requestNumber
      status
    }
  }
`;
